import { FilterHandler } from '../shared/filter-handler';

import { FaoZone } from './fao-zone';
import { Port } from './port';
import { Ship } from './ship';
import { Specie } from './specie';

export class ExportFilter extends FilterHandler {
  specie: Specie[] = [];
  ship: Ship[] = [];
  start_date: string;
  end_date: string;

  constructor(values: Object = {}) {
    super();

    this.specie = [];
    this.ship = [];
    this.start_date = '';
    this.end_date = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/export.ts